import React, {useCallback, useEffect, useState} from 'react';
import {useRecoilState} from 'recoil';
import {loadingAtom} from '../../atoms';
import {findSectorsByQueryString, getDefaultSaleSectors, saveDefaultSaleSectors} from '../../utils/requestUtils';
import '../company/CompanyClosedDaysCalendar.css';

const SaleDefaultSectorsConfig = () => {
    const [, setLoading] = useRecoilState(loadingAtom);
    const [sectors, setSectors] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [savedIds, setSavedIds] = useState([]);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const isDirty = JSON.stringify([...selectedIds].sort()) !== JSON.stringify([...savedIds].sort());

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const [allSectors, defaultIds] = await Promise.all([
                findSectorsByQueryString(''),
                getDefaultSaleSectors(),
            ]);
            setSectors(allSectors);
            setSelectedIds(defaultIds);
            setSavedIds(defaultIds);
        } catch {
            setErrorMessage('Não foi possível carregar os dados.');
        } finally {
            setLoading(false);
        }
    }, [setLoading]);

    useEffect(() => {
        load();
    }, [load]);

    const toggle = (id) => {
        setSuccessMessage('');
        setErrorMessage('');
        setSelectedIds(prev => prev.includes(id) ? prev.filter(s => s !== id) : [...prev, id]);
    };

    const toggleAll = () => {
        setSuccessMessage('');
        setErrorMessage('');
        const allSelected = selectedIds.length === sectors.length;
        setSelectedIds(allSelected ? [] : sectors.map(s => s.id));
    };

    const onSave = async () => {
        if (!isDirty) return;
        setLoading(true);
        try {
            await saveDefaultSaleSectors(selectedIds);
            setSavedIds([...selectedIds]);
            setSuccessMessage('Setores padrão salvos com sucesso.');
        } catch {
            setErrorMessage('Não foi possível salvar. Tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    const allSelected = sectors.length > 0 && selectedIds.length === sectors.length;

    return (
        <div className="company-closed-days-calendar">
            <div className="header-label">Setores padrão — Tela de Serviços</div>

            <div style={{maxWidth: '360px', margin: '16px auto', display: 'flex', flexDirection: 'column', gap: '4px'}}>
                <p style={{margin: '0 0 8px', fontSize: '13px', color: '#555'}}>
                    Os setores marcados serão pré-selecionados automaticamente na tela de consulta de serviços.
                    Deixe todos desmarcados para não aplicar nenhum filtro padrão.
                </p>

                <label style={{display: 'flex', alignItems: 'center', gap: '6px', padding: '2px 4px', cursor: 'pointer', fontWeight: 600, textTransform: 'uppercase'}}>
                    <input type="checkbox" checked={allSelected} onChange={toggleAll} />
                    Todos
                </label>

                {sectors.map(sector => (
                    <label key={sector.id} style={{display: 'flex', alignItems: 'center', gap: '6px', padding: '2px 4px', cursor: 'pointer', textTransform: 'uppercase'}}>
                        <input
                            type="checkbox"
                            checked={selectedIds.includes(sector.id)}
                            onChange={() => toggle(sector.id)}
                        />
                        {sector.name}
                    </label>
                ))}
            </div>

            <div className="calendar-actions">
                <button onClick={load}>Recarregar</button>
                <button onClick={onSave} disabled={!isDirty}>Confirmar</button>
            </div>

            {successMessage && <div className="calendar-status calendar-status-success">{successMessage}</div>}
            {errorMessage && <div className="calendar-status calendar-status-error">{errorMessage}</div>}
        </div>
    );
};

export default SaleDefaultSectorsConfig;
